/* eslint-disable react/no-unknown-property */
/* eslint-disable react/jsx-key */
import React, { useEffect, useRef, useState } from 'react'
import Header3 from '../components/header/header-rslhome'
import FooterRSL from '../components/footer/footer-new'
import Seo from '../components/common/Seo'
// import GoogleMap from '../components/staycations/googleMap';
import { fetchSeoByPage } from '../lib/seoHelper'


const LocateUs = ({ meta }) => {
  return (
    <>
      <Seo meta={meta} />
      <Header3 bgColor="#EBEBEB" borderColor="#DFDFDF" />
      <div className='careers-main mt-careers-main'>
        <div className='rule'></div>
        <div className='container' style={{ marginTop: '50px' }}>
          <div className='text-center'>
            <h1 className='mb-10 text-uppercase'>
              You&apos;re in the Right Place!
            </h1>
            <p>Need to find us? Look below and head over!</p>
          </div>

          <div class='row text-center mt-40'>
            <section className='mb-20' id='facilities'>
              <div className='container-md'>
                <div className='row y-gap-40'>
                  <div className='col-12'>
                    {/* <GoogleMap
                      apiKey={apiKey}
                      latitude={25.232358}
                      longitude={55.555734}
                    /> */}
                    <iframe
                      src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d35950.70606048042!2d55.537425318838196!3d25.2393306407588!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ef58b654f20222d%3A0x99bc6b503c833237!2sALT%20TECHNOLOGIES!5e0!3m2!1sen!2sin!4v1742555227390!5m2!1sen!2sin'
                      width='100%'
                      height='450'
                      style={{ border: 0 }}
                      allowFullScreen
                      loading='lazy'
                      referrerPolicy='no-referrer-when-downgrade'
                    ></iframe>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
      <FooterRSL />
    </>
  )
}

export default LocateUs;

export async function getServerSideProps(context) {
  const rawPath = context.resolvedUrl;
  let path = rawPath.split("?")[0];
  if (path.length > 1 && path.endsWith("/")) {
    path = path.slice(0, -1);
  }
  const metaHome = await fetchSeoByPage(path);
  return {
    props: { meta: metaHome }
  };
}